import { render, staticRenderFns } from "./minePage.vue?vue&type=template&id=72b16157&scoped=true&"
import script from "./minePage.vue?vue&type=script&lang=js&"
export * from "./minePage.vue?vue&type=script&lang=js&"
import style0 from "./minePage.vue?vue&type=style&index=0&id=72b16157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b16157",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b16157')) {
      api.createRecord('72b16157', component.options)
    } else {
      api.reload('72b16157', component.options)
    }
    module.hot.accept("./minePage.vue?vue&type=template&id=72b16157&scoped=true&", function () {
      api.rerender('72b16157', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/minePage.vue"
export default component.exports